import userService from '../helpers/user.service'
import router from '../router'

const menus = JSON.parse(localStorage.getItem('menus'))
const state = () => {
  return {
    menu: menus || [],
    menu_old: [
      {
        icon: 'HomeIcon',
        pageName: 'dashboard',
        title: 'Dashboard',
        subMenu: [
          {
            icon: '',
            pageName: 'modules',
            title: 'Overview 1'
          },
          {
            icon: '',
            pageName: 'dashboard',
            title: 'Overview 2'
          }
        ]
      }
    ]
  }
}

const getters = {
  menu: state => state.menu
}

const mutations = {
  add(state, data) {
    state.menu = data
  },
  clear(state) {
    state.menu = []
  }
}
const actions = {
  add({ commit }, payload) {
    commit('clear')
    commit('add', payload)
  },
  loginMenus({ commit }, payload) {
    userService
      .checkInMenus(payload)
      .then(menu => {
        commit('add', menu)
        return menu
      })
      .then(menu => {
        if (menu.length > 0) {
          router.push(menu[0].link)
        } else {
          router.push('/error-page')
        }
      })
  },
  loginMenuFilter({ commit }, moduleName) {
    userService.checkOutMenus()
    commit('clear')

    this.state.auth.role.modules.find(module => {
      if (module.module === moduleName) {
        userService.checkInMenus(module).then(menu => {
          commit('add', menu)
          return menu
        })
        // .then(menu => {
        //   if (menu.length > 0) {
        //     router.push(menu[0].link)
        //   } else {
        //     router.push('/error-page')
        //   }
        // })
      }
    })
  },
  logoutMenus({ commit }) {
    userService.checkOutMenus()
    commit('clear')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
